import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  private readonly key = environment.tokenKey;

  get(): string | null {
    return localStorage.getItem(this.key);
  }
  set(token: string): void {
    localStorage.setItem(this.key, token);
  }
  clear(): void {
    localStorage.removeItem(this.key);
  }
  has(): boolean {
    return !!this.get();
  }
}
